export default {
    updateAuthStore(state, { access, refresh, isAuthenticated }) {
        state.accessToken = access;
        state.refreshToken = refresh;
        sessionStorage.setItem('accessToken', access);
        sessionStorage.setItem('refreshToken', refresh);
        state.isAuthenticated = isAuthenticated;
        sessionStorage.setItem('authenticated', isAuthenticated);
    },
}